import { getSettingsInstance } from "./Settings";
import { formatDateTime } from "../../api/date";
import * as dev from '../../api/dev'

/**
 * record structure:
 */
const fields = [
    'id',
    'type',
    'state',
    'datetime',
    'dispatcherID',
    'dispatcherName',
    'fromID',
    'fromName',
    'content'
]

export const ALERT_TYPES = {
    ENTRY: 1,
    LEAVE: 2,
    SPEED: 3
}


export class AlertLogger{

    constructor(indexedDB){

        this.db = null;

        this.indexedDB = indexedDB

        this.indexedDB.addUpgradeListener(this.onUpgradeNeeded.bind(this))
        this.indexedDB.addConnectListener(this.onConnect.bind(this))
        //this.connect();
        
        this.dispatcherName = '';
        this.dispatcherID = '';

        this.deleteListeners = []

    }

    addDeleteListener(callback){
        this.deleteListeners.push(callback)
    }

    onConnect(db){

        this.db = db

        //clean now
        this.cleanUp()
        //and every 3 hours
        this.cleanUpTimer = setInterval(this.cleanUp.bind(this), 1000*60*60*3)
    }


    onUpgradeNeeded(event){
        //alert('AlertsLogger onUpgradeNeeded')
        console.log('db AlertsLog upgrade needed')

        let transaction = event.target.transaction;
        this.db = event.target.result;

        let alertsLogStore
        if (!this.db.objectStoreNames.contains('AlertsLog')) {
            console.log('create AlertsLog store')
            alertsLogStore = this.db.createObjectStore("AlertsLog", { keyPath : "id", autoIncrement: true  });
        }else{
            console.log('exist store AlertsLog')
        }

        if(!alertsLogStore){
            alertsLogStore = transaction.objectStore('AlertsLog');
        } 

        

        //let dateIndex
        try {
            //dateIndex = 
            alertsLogStore.index("date_idx");
            console.log('exist index AlertsLog.date_idx')
        } catch (error) {
            if(error.name==='NotFoundError'){
                console.log('create AlertsLog.date_idx')
                //dateIndex = 
                alertsLogStore.createIndex('date_idx', 'datetime');
            }
        }

        //let typeIndex
        try {
            //typeIndex = 
            alertsLogStore.index("type_idx");
            console.log('exist index AlertsLog.type_idx')
        } catch (error) {
            if(error.name==='NotFoundError'){
                console.log('create AlertsLog.type_idx')
                //typeIndex = 
                alertsLogStore.createIndex('type_idx', 'type');
            }
        }

        //let stateIndex
        //alertsLogStore.deleteIndex('state_idx')
        try {
            //stateIndex = 
            alertsLogStore.index("state_idx");
            console.log('exist index AlertsLog.state_idx')
        } catch (error) {
            if(error.name==='NotFoundError'){
                console.log('create AlertsLog.state_idx')
                //stateIndex = 
                alertsLogStore.createIndex('state_idx', 'state');
            }
        }


        //let refIdIndex
        try {
            //refIdIndex = 
            alertsLogStore.index("device_id_idx");
            console.log('exist index AlertsLog.device_id_idx')
        } catch (error) {
            if(error.name==='NotFoundError'){
                console.log('create AlertsLog.device_id_idx')
                //refIdIndex = 
                alertsLogStore.createIndex('device_id_idx', 'deviceID');
            }
        }

        //let refDeviceIndex
        try {
            //refDeviceIndex = 
            alertsLogStore.index("device_name_idx");
            console.log('exist index AlertsLog.device_name_idx')
        } catch (error) {
            if(error.name==='NotFoundError'){
                console.log('create AlertsLog.device_name_idx')
                //refDeviceIndex = 
                alertsLogStore.createIndex('device_name_idx', 'deviceName');
            }
        }
    
    };

    connected(){
        return Boolean(this.db)
    }

    /**
     * add event to log
     */
    add(alert){

        if(!this.connected()) return

        if(alert.date === undefined){
            alert.datetime = new Date().getTime()
        } 

        if(alert.dispatcherName === undefined){
            alert.dispatcherName = this.dispatcherName
        }
        if(alert.dispatcherID === undefined){
            alert.dispatcherID = this.dispatcherID
        }

        //console.log('Add Event')
        //console.log(event)
        if(!this.check(alert)) return

        const transaction = this.db.transaction(["AlertsLog"],"readwrite");
        transaction.oncomplete = function(event) {
            //console.log("Success");
        };

        transaction.onerror = function(event) {
            //console.log("Error");
        };  
        const log = transaction.objectStore("AlertsLog");
        log.add(alert);
    }

    check(alert){
        //check for required fields
        if(alert.type === undefined){
            window.alert('AlertsLog: alert.type is not defined')
            return false
        }
        if(alert.datetime === undefined){
            window.alert('AlertsLog: alert.datetime is not defined')
            return false
        }
        if(alert.fromName === undefined){
            window.alert('AlertsLog: alert.fromName is not defined')
            return false
        }

        //console.log(Object.keys(event))
        Object.keys(alert).forEach(item => {
            //console.log('item ' + item)
            if(fields.indexOf(item)===-1){
                window.alert("AlertsLog: unexpected field "+item)
                return false
            }
        })

        return true
    }

    setDispatcherName(name){
        this.dispatcherName = name
    }
    setDispatcherID(id){
        this.dispatcherID = id
    }

    /*
    updateState(refID, state){
        console.log('updateState')
        const transaction = this.db.transaction(["AlertsLog"], "readwrite")
        const alertsLogStore = transaction.objectStore("AlertsLog")
        const refIndex = alertsLogStore.index("ref_id_idx")

        if(refID){
            const request = refIndex.get(refID)
            request.onsuccess = function() {
                if (request.result !== undefined) {
                    console.log('request.result')
                    console.log(request.result)
                    let event = request.result
                    event.state = state

                    transaction.oncomplete = function(event) {
                        console.log("Success")
                    }
            
                    transaction.onerror = function(event) {
                        console.log("Error")
                    }
                    //const log = transaction.objectStore("AlertsLog");
                    alertsLogStore.put(event)

                }
            }
        }

    }
    */

    update(id, updatedFields){
        console.log('updateAlert')
        const transaction = this.db.transaction(["AlertsLog"], "readwrite")
        const alertsLogStore = transaction.objectStore("AlertsLog")
        //const refIndex = alertsLogStore.index("id_idx")

        if(id){
            const request = alertsLogStore.get(id)
            request.onsuccess = function() {
                if (request.result !== undefined) {
                    console.log('request.result')
                    console.log(request.result)
                    let alert = {...request.result, ...updatedFields}

                    transaction.oncomplete = function(event) {
                        console.log("Success")
                    }
            
                    transaction.onerror = function(event) {
                        console.log("Error")
                    }
                    //const log = transaction.objectStore("AlertsLog");
                    alertsLogStore.put(alert)

                }
            }
        }

    }


    queryAlerts(filter, onsuccess, onerror){
        //select events from db
        if(!this.connected()) return

        console.log('queryAlerts')
        const transaction = this.db.transaction(["AlertsLog"], "readonly");
        const alertsLogStore = transaction.objectStore("AlertsLog");
        let cursor
        let useFilter = true
        let useSort = true

        console.log('AlertsLog')
        console.log(filter)

        //let request
        let range
        if(filter.dateFrom || filter.dateTo){
            console.log('use date_idx')
            const dateIndex = alertsLogStore.index("date_idx");

            let timeFrom = filter.dateFrom ? filter.dateFrom.getTime() : null
            let timeTo = filter.dateTo ? filter.dateTo.getTime() : null

            if(timeFrom && timeTo && timeFrom<timeTo){
                range = IDBKeyRange.bound(timeFrom, timeTo)    
            }else if(timeFrom && timeTo && timeFrom>timeTo){
                range = IDBKeyRange.bound(timeTo, timeFrom)    
            }else if(timeFrom){
                range = IDBKeyRange.lowerBound(timeFrom)    
            }else if(timeTo){
                range = IDBKeyRange.upperBound(timeTo)  
            }

            cursor = dateIndex.openCursor(range, 'prev')

            //useFilter = false
            //useSort = false

        }else if(filter.state && !Array.isArray(filter.state)){

            console.log('use state_idx')
            const stateIndex = alertsLogStore.index("state_idx");
            //range = filter.type
            range = IDBKeyRange.only(filter.state)
            cursor = stateIndex.openCursor(range)

            useFilter = true
            useSort = true

        }else if(filter.type && !Array.isArray(filter.type)){

            console.log('use type_idx')
            const typeIndex = alertsLogStore.index("type_idx");
            range = filter.type
            //range = IDBKeyRange.only(filter.type)  
            cursor = typeIndex.openCursor(range)

            useFilter = true
            useSort = true

        }else{
        /*
        else if(filter.ref_device_id && !Array.isArray(filter.ref_device_id)){

            console.log('use ref_device_id_idx')
            const refDeviceIndex = alertsLogStore.index("ref_device_id_idx");
            range = filter.ref_device_id
            //range = IDBKeyRange.only(filter.type)  
            cursor = refDeviceIndex.openCursor(range)

            useFilter = true
            useSort = true

        }*/
            console.log('use date_idx (default)')
            const dateIndex = alertsLogStore.index("date_idx");
            range = null
            cursor = dateIndex.openCursor(range, 'prev')

            useSort = false
        }
        
        //console.log('useFilter')
        //console.log(useFilter)

        let result = []
        let count = 0
        cursor.onsuccess = event => {
            let cursor = event.target.result;
            if(cursor) {
                //console.log('cursor.value')
                //console.log(cursor.value)
                if(!useFilter || itemFilter(cursor.value, filter)){
                    result.push(cursor.value)
                }
                count ++
                cursor.continue();
            }else{
                //console.log('cursor.complete '+ result.length)
                if(useSort){
                    result = sort(result)
                }
                console.log('count')
                console.log(count)
                onsuccess(result)
            }
        }
       
        cursor.onerror = event => {
            onerror(event)
        }

        /*
        request.onsuccess = ()=>{
            alert('success')
            onsuccess(request.result)
        }
        request.onerror = ()=>{
            alert('error')
            onerror()
        }
        */

    }


    cleanUp(){

        const settings = getSettingsInstance()

        const clearDataDays = settings.get('clearDataDays')
        
        if(clearDataDays>0){

            let hasStore = this.db.objectStoreNames.contains('AlertsLog')
            if(!hasStore){
                //alert('not has AlertsLog Store!')
                return
            }

            const date = new Date()
            date.setDate(date.getDate() - clearDataDays)

            //alert(formatDateTime(date.getTime(), 'full_date'))
            console.log('events log cleanup before ' + formatDateTime(date.getTime()))

            const transaction = this.db.transaction(["AlertsLog"], "readwrite");

            const alertsLogStore = transaction.objectStore("AlertsLog");
            const range = IDBKeyRange.upperBound(date.getTime()) 

            const dateIndex = alertsLogStore.index("date_idx");
            const cursor = dateIndex.openCursor(range)

            cursor.onsuccess = event => {
                let cursor = event.target.result;
                if(cursor) {

                    this.deleteListeners.forEach(callback => {
                        callback(cursor.value)
                    })

                    //console.log('cursor.value')
                    //console.log(cursor.value)
                    alertsLogStore.delete(cursor.value.id)
                    //console.log('delete event ' + cursor.value.id)
                    cursor.continue();
                }else{
                    console.log('cleanup complete')
                }
            }

        }

    }

}

function itemFilter(item, filter){
    //let check = true
    //console.log('itemFilter')
    //console.log(item)
    //console.log(filter)

    if(filter.type){

        if(Array.isArray(filter.type)){
            //console.log('type filter ' + item.type)
            //console.log(filter.type.includes(item.type))
            if(!filter.type.includes(item.type)) return false
        }else{
            if(filter.type!==item.type) return false
        }

    }

    //if(filter.ref_user_id && filter.ref_user_id!==item.ref_user_id) return false
    //if(filter.ref_device_id && filter.ref_device_id!==item.ref_device_id) return false
    //if(filter.ref_group_id && filter.ref_group_id!==item.ref_group_id) return false

    return true
}

function sort(events){
    events.sort((item1, item2) => (item1.datetime < item2.datetime))
    return events
}

export function getAlertTypeName(type){
    switch(type){
        case ALERT_TYPES.ENTRY: return 'Entry'; 
        case ALERT_TYPES.LEAVE: return 'Leave'; 
        case ALERT_TYPES.SPEED: return 'Speed';    
        default: 
            dev.alert('Translation for type '+type+' not defined' )
    } 
}